<template>
  <div class="sidebar">
    <ul class="baritems">
      <router-link to="/reports/dashboard">
        <li>Dashboard</li>
      </router-link>
      <router-link to="/reports/benchmarking">
        <li>Benchmarking</li>
      </router-link>
      <!-- <router-link to="/reports/overall">
      <li>
          Overall grades
      </li>
        </router-link> -->
      <!-- <router-link to="/reports/sections">
      <li>
          Section grades
      </li>
        </router-link> -->
      <router-link to="/reports/custom">
        <li>Custom Graphs</li>
      </router-link>
      <router-link to="/reports/query-data" v-if="canViewExtraReports">
        <li>Explore Data</li>
      </router-link>
      <router-link to="/gradings" v-if="canViewExtraReports">
        <li>Further Data</li>
      </router-link>
      <router-link to="/sectiondata" v-if="canViewExtraReports">
        <li>Section Comments</li>
      </router-link>
      <router-link to="/reports/export-audits" v-if="canViewExtraReports">
        <li>Export Audits</li>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SideBar',
  computed: {
    ...mapGetters({ role: 'user/role' }),
    canViewExtraReports () {
      return ['manage', 'admin', 'super'].includes(this.role)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/variables.scss';
@import '@/style/nav.scss';

.text-sm {
  font-size: 0.75rem;
}
</style>
